<template>
  <div>
    <b-table
      responsive
      striped
      hover
      :items="item.children"
      :fields="fields_table_info"
      :currentPage="pagination.currentPage"
      :perPage="pagination.perPage"
    >
      <template #cell(cnpj)="{ item }">
        {{ item.cnpj }}
        <small class="text-muted d-block">{{ item.beneficiario }}</small>
      </template>
      <template #cell(repasse)="{ item }">
        {{ item.repasse | number_format }}
      </template>
      <template #cell(info)="{ item }">
        <font-awesome-icon
          icon="exclamation-triangle"
          v-if="item.info == 'Erro'"
          @click="showError(item.erros)"
        />
        {{ item.info }}
      </template>
    </b-table>

    <b-row class="mt-4" v-if="item.children.length > 0">
      <b-col>
        <b-pagination
          v-model="pagination.currentPage"
          :total-rows="item.children.length"
          :per-page="pagination.perPage"
          size="sm"
        ></b-pagination>
      </b-col>

      <b-col>
        <b-form-group
          label="Exibir"
          label-cols="8"
          label-align="right"
          label-size="sm"
        >
          <b-form-select
            v-model="pagination.perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      require: true,
    },
  },
  data: () => ({
    pagination: {
      currentPage: 1,
      perPage: 10,
    },
    pageOptions: [5, 10, 15, 50],
  }),
  computed: {
    fields_table_info() {
      return [
        { key: "codigo", label: "Código", sortable: true },
        { key: "emenda", label: "Nº Emenda", sortable: true },
        { key: "parlamentar", label: "Parlamentar", sortable: true },
        { key: "cnpj", label: "CNPJ", sortable: true },
        {
          key: "type",
          label: "Tipo de Benefício",
          sortable: true,
        },
        {
          key: "repasse",
          label: "Repasse",
          sortable: true,
        },

        {
          key: "info",
          label: "#",
          sortable: true,
        },
      ];
    },
  },
  methods: {
    showError(msg) {
      this.$bvModal.msgBoxOk("ERRO: " + msg, {
        centered: true,
      });
    },
  },
};
</script>

<style></style>
